module.exports = __webpack_public_path__ + "img/15_1807_bb_house.4662778c.jpg";